import { QueryClient } from '@tanstack/react-query'

// Create a React Query client - exported separately to avoid circular imports
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
})
